<div
	class="search-container"
	[class.collapsed]="isSidenavCollapsed()"
>
	@if (!isSidenavCollapsed()) {
		<div
			class="search-box"
			(click)="openGlobalSearch()"
		>
			<span class="search-icon">
				<i class="fa-solid fa-search"></i>
			</span>
			<input
				type="text"
				[placeholder]="'components.globalSearch.globalSearchInputPlaceholder' | translate"
				class="search-input"
				(click)="$event.stopPropagation()"
				(focus)="openGlobalSearch()"
				readonly
			/>
		</div>
	} @else {
		<button
			class="search-icon-only"
			(click)="openGlobalSearch()"
		>
			<i class="fa-solid fa-search"></i>
		</button>
	}
</div>

<!-- Global Search Component -->
@let globalSearchOpened = globalSearchStore.state().isOpen;
@defer (when !globalSearchOpened) {
	<dc-global-search-container [class.collapsed]="!globalSearchOpened" />
} @placeholder {
	<div></div>
}
